module.exports = __webpack_public_path__ + "img/yingye.62434ee0.png";